import { GolfTournament } from '@img-arena/consoles-api-dde'
import { Column, COLUMN_CELL_TYPE, Filter } from '@/components/table/base'

export type GolfPricingRow = {
  id: number
  tournamentName: string
  rounds: number
  courseName: string | null
  startDate: string | null
  startDateTime: string | null
  endDate: string | null
  location: string | null
}

export const GOLF_PRICING_TABLE_COLUMNS: Column<GolfPricingRow>[] = [
  {
    type: COLUMN_CELL_TYPE.TEXT,
    id: 'tournamentName',
    label: 'Tournament',
    sortAttribute: 'tournamentName'
  },
  {
    type: COLUMN_CELL_TYPE.NUMBER,
    id: 'rounds',
    label: 'Rounds',
    sortAttribute: 'rounds'
  },
  {
    type: COLUMN_CELL_TYPE.TEXT,
    id: 'courseName',
    label: 'Course',
    sortAttribute: 'courseName'
  },
  {
    type: COLUMN_CELL_TYPE.DATE,
    id: 'startDateTime',
    label: 'Start Date',
    sortAttribute: 'startDateTime',
    dateFormat: 'dd-MM-yyyy HH:mm'
  },
  {
    type: COLUMN_CELL_TYPE.DATE,
    id: 'endDate',
    label: 'End Date',
    sortAttribute: 'endDate',
    dateFormat: 'dd-MM-yyyy'
  },
  {
    type: COLUMN_CELL_TYPE.TEXT,
    id: 'location',
    label: 'Location'
  }
]

export const getGolfPricingTableFilters = (): Filter<GolfPricingRow>[] => {
  return [
    {
      type: 'freeTextSearch',
      paramName: 'ft',
      placeholder: 'Search',
      filterOptions: (row, search) => {
        if (!search) return true
        const lowerCaseSearch = search.toLowerCase()
        return (
          row.tournamentName.toLowerCase().includes(lowerCaseSearch) ||
          row.courseName?.toLowerCase().includes(lowerCaseSearch) ||
          row.location?.toLowerCase().includes(lowerCaseSearch) ||
          row.id.toString().includes(lowerCaseSearch)
        )
      }
    },

    {
      type: 'date',
      roundTo: 'start',
      label: 'Start Date',
      paramName: 'startDate',
      filterOptions: (row, selectedDate: Date | null | undefined) => {
        if (!selectedDate) return true
        if (!row.startDate || !row.endDate) return true

        const filterStartDate = new Date(
          selectedDate.getFullYear(),
          selectedDate.getMonth(),
          selectedDate.getDate()
        )
        const tournamentEndDate = new Date(
          new Date(row.endDate).getFullYear(),
          new Date(row.endDate).getMonth(),
          new Date(row.endDate).getDate()
        )

        return tournamentEndDate.getTime() >= filterStartDate.getTime()
      }
    },
    {
      type: 'date',
      roundTo: 'end',
      label: 'End Date',
      paramName: 'endDate',
      filterOptions: (row, selectedDate: Date | null | undefined) => {
        if (!selectedDate) return true
        if (!row.startDate || !row.endDate) return true

        const filterEndDate = new Date(
          selectedDate.getFullYear(),
          selectedDate.getMonth(),
          selectedDate.getDate(),
          23,
          59,
          59,
          999
        )
        const tournamentStartDate = new Date(
          new Date(row.startDate).getFullYear(),
          new Date(row.startDate).getMonth(),
          new Date(row.startDate).getDate()
        )

        return tournamentStartDate.getTime() <= filterEndDate.getTime()
      }
    }
  ]
}

export const getGolfPricingTableRows = (data: GolfTournament[]): GolfPricingRow[] => {
  return data.map((golfTournament) => ({
    id: golfTournament.id,
    tournamentName: golfTournament.name,
    rounds: golfTournament.rounds.length,
    courseName: golfTournament.mainGolfCourseName,
    startDate: golfTournament.startDate,
    startDateTime: golfTournament.startTeeTime,
    endDate: golfTournament.endDate,
    location: golfTournament.venue
  }))
}
